import { render, staticRenderFns } from "./OverallChatCountChart.vue?vue&type=template&id=0f2b3d42&scoped=true"
import script from "./OverallChatCountChart.vue?vue&type=script&lang=js"
export * from "./OverallChatCountChart.vue?vue&type=script&lang=js"
import style0 from "./OverallChatCountChart.vue?vue&type=style&index=0&id=0f2b3d42&prod&lang=scss"
import style1 from "./OverallChatCountChart.vue?vue&type=style&index=1&id=0f2b3d42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b3d42",
  null
  
)

export default component.exports